import React from "react";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/download.svg";
import { ReactComponent as CopyIcon } from "../../../assets/icons/copyToClipboard.svg";
import { ReactComponent as ExpandIcon } from "../../../assets/icons/expandIconDVF.svg";

/** Shared result-toolbar glyphs used by Collection Build and Image Generator. */
export { DownloadIcon, CopyIcon, ExpandIcon };

export const iconGlyphClassName = "h-6 w-6 [&_path]:fill-current";
export const iconGlyphCompactClassName = "h-4 w-4 [&_path]:fill-current";
export const expandGlyphCompactClassName =
  "h-3.5 w-3.5 [&_path]:stroke-current";
export const expandGlyphClassName = "h-5 w-5 [&_path]:stroke-current";

/** Canonical result-action button (Collection Build moodboard / below-image tools). */
export const generativeResultToolBtnClassName =
  "flex h-10 w-10 items-center justify-center rounded-full border border-[#E8E8E8] bg-white text-[#1A1A1A] shadow-[0_2px_8px_rgba(0,0,0,0.16)] transition-colors hover:bg-[#F7F7F7] focus:outline-none disabled:cursor-not-allowed disabled:opacity-40";

/** Compact on-image overlay variant — same circle/border language, smaller hit target. */
export const generativeResultToolBtnCompactClassName =
  "flex h-7 w-7 items-center justify-center rounded-full border border-[#E8E8E8] bg-white text-[#4A4A4A] shadow-[0_1px_3px_rgba(0,0,0,0.16)] transition-colors hover:bg-[#F7F7F7] focus:outline-none disabled:cursor-not-allowed disabled:opacity-40";

/** Compact IG-style download format menu (PDF / JPEG / PNG / SVG). */
export const generativeDownloadMenuClassName =
  "absolute z-30 flex flex-col gap-1 rounded-xl border border-[#D0D0D0] bg-white p-1.5 shadow-md";

export const generativeDownloadMenuItemClassName =
  "h-7 min-w-[3.25rem] rounded-full border border-[#737373] px-2.5 text-xs leading-none text-secondary hover:border-[#737373] hover:bg-gray";

const THUMB_PATH =
  "M8.97107 14.316H5.00507C4.68307 14.316 4.36507 14.236 4.08007 14.084C3.79203 13.9307 3.54587 13.7093 3.36307 13.439C3.17769 13.1662 3.05918 12.8536 3.01713 12.5264C2.97509 12.1993 3.01069 11.8668 3.12107 11.556L5.48107 4.355C5.77007 3.54 5.96107 3 7.36607 3C9.43807 3 11.6421 3.678 13.5221 4.256C13.9951 4.401 14.4471 4.54 14.8721 4.66H14.9861V14.522C13.3282 16.1578 11.9023 18.0131 10.7481 20.036C10.5511 20.412 10.2321 20.706 9.84707 20.866C9.46249 21.0264 9.03314 21.0434 8.63707 20.914C8.23855 20.7814 7.89895 20.5136 7.67707 20.157C7.45222 19.7957 7.35733 19.3685 7.40807 18.946L8.97007 14.316H8.97107ZM19.8231 14H17.0011V6C17.0011 5.46957 17.2118 4.96086 17.5869 4.58579C17.9619 4.21071 18.4706 4 19.0011 4C19.5315 4 20.0402 4.21071 20.4153 4.58579C20.7904 4.96086 21.0011 5.46957 21.0011 6V12.823C21.0011 13.473 20.4731 14 19.8231 14Z";

/** Outline when idle, solid fill when selected. */
export const ThumbIcon: React.FC<{
  filled?: boolean;
  className?: string;
  sizeClassName?: string;
}> = ({ filled = false, className = "", sizeClassName = "h-6 w-6" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    className={`${sizeClassName} ${className}`}
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d={THUMB_PATH}
      fill={filled ? "currentColor" : "none"}
      stroke="currentColor"
      strokeWidth={filled ? 0 : 1.35}
      strokeLinejoin="round"
    />
  </svg>
);

export const RegenerateIcon: React.FC<{ className?: string }> = ({
  className = "h-6 w-6",
}) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <path
      d="M20 15.5A8 8 0 1 1 16.5 5.2"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <path
      d="M20 4.5v6h-6"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
